import React, { Component } from "react";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  styled,
  Typography,
} from "@mui/material";
import Repo from "../Repository/Repo";

const BillForm = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  pading: "20px",
});

export default class templates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      template: "standard",
    };
  }

  componentDidMount() {
    this.fetchTemplate();
  }

  fetchTemplate() {
    Repo.template({
      request: {
        method: "getTemplate",
        data: {
          company_code: localStorage.getItem("companyCode"),
        },
      },
    }).then(({ data }) => {
      this.setState({ template: data.response.data.template });
      localStorage.setItem("template", data.response.data.template);
    });
  }
  updateTemplate() {
    Repo.template({
      request: {
        method: "saveTemplate",
        data: {
          template: this.state.template,
          company_code: localStorage.getItem("companyCode"),
        },
      },
    }).then((resp) => {
      toast.configure();
      toast.info("Template updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
      this.fetchTemplate();
    });
  }
  handleChange = (event) => {
    this.setState({ template: event.target.value });
  };

  render() {
    return (
      <Box sx={{ margin: "50px 0px" }}>
        <Container
          sx={{
            background: "white",
            padding: "10px",
            borderRadius: "6px",
          }}
        >
          <Typography variant="h6" sx={{ mb: "20px", color: "#4EAF51" }}>
            Bill Templates
          </Typography>
          <BillForm>
            <FormControl sx={{ width: "100%" }} component="fieldset">
              <FormLabel component="legend">Template types</FormLabel>
              <RadioGroup
                aria-label="Temp"
                name="gender1"
                sx={{
                  display: "grid !important",
                  gridTemplateColumns: "33% 33% 33% !important",
                  rowGap: "15px",
                  width: "100% !important",
                  marginTop: "10px",
                }}
                value={this.state.template}
                onChange={this.handleChange}
              >
                <FormControlLabel
                  value="standard"
                  control={<Radio />}
                  label="Standard"
                  className="label-adj"
                />
                <FormControlLabel
                  className="label-adj"
                  value="standardTwo"
                  control={<Radio />}
                  label="Standard 2"
                />
                <FormControlLabel
                  className="label-adj"
                  value="thermal"
                  control={<Radio />}
                  label="Thermal"
                />
                {localStorage.getItem("companyCode") == 7771 ||
                localStorage.getItem("companyCode") == 4300 ||
                localStorage.getItem("companyCode") == 1178 ? (
                  <FormControlLabel
                    className="label-adj"
                    value="thermalInvoice"
                    control={<Radio />}
                    label="Thermal (Invoice)"
                  />
                ) : null}
                <FormControlLabel
                  className="label-adj"
                  value="warehouse"
                  control={<Radio />}
                  label="Warehouse"
                />
                <FormControlLabel
                  className="label-adj"
                  value="standard_warehouse"
                  control={<Radio />}
                  label="Standard + Warehouse"
                />
                <FormControlLabel
                  className="label-adj"
                  value="standardTwoDeliveryChallan"
                  control={<Radio />}
                  label="Standard 2 + Delivery Challan"
                />
                <FormControlLabel
                  className="label-adj"
                  value="three_copies"
                  control={<Radio />}
                  label="Three Copies"
                />
                    <FormControlLabel
                  className="label-adj"
                  value="standard_urdu"
                  control={<Radio />}
                  label="Standard Urdu"
                />
                    <FormControlLabel
                  className="label-adj"
                  value="standard_user"
                  control={<Radio />}
                  label="Standard User Print"
                />
                   <FormControlLabel
                  className="label-adj"
                  value="design_five"
                  control={<Radio />}
                  label="Design Five Print"
                />
                    <FormControlLabel
                  className="label-adj"
                  value="design_six"
                  control={<Radio />}
                  label="Design Six Print"
                />
                  <FormControlLabel
                  className="label-adj"
                  value="design_seven"
                  control={<Radio />}
                  label="Design Seven Print"
                />
              </RadioGroup>
            </FormControl>

            <Button
              className="btn-succ w100p mt10"
              style={{ float: "right" }}
              onClick={() => {
                this.updateTemplate();
                // this.setState({ isNew: true });
              }}
            >
              Save
            </Button>
          </BillForm>
        </Container>
      </Box>
    );
  }
}
